import { doctorAutocomplete } from '@medifind/interface';
import { StoreFilterAutocomplete } from '@medifind/search-results';
import { SearchSuggestion } from '@medifind/shared-basic-components';
import { clearDoctorDoctorFilterOption, useFilterContext } from '@medifind/zustand';

const StoreDoctorFilter = ({ ...props }) => {
  const filters = useFilterContext();
  const { doctorDoctor } = filters.states;

  const handleDoctorAutoComplete = async (input) => {
    if (input) {
      try {
        if (!input?.trim()) throw new Error('more-char');
        const data = await doctorAutocomplete({ input: input.trim() });
        if (data.needCharacters) throw new Error('more-char');

        return data.results.map((d) => ({ ...d, display: d.name, value: d.personId }));
      } catch (e) {
        return 'Type a few more characters';
      }
    }
    return [];
  };

  return (
    <>
      <StoreFilterAutocomplete
        id="ac-doctor-filter"
        filter={doctorDoctor}
        label="Doctor"
        placeholder={'Search for a doctor...'}
        autocompleteFunction={handleDoctorAutoComplete}
        prepopulateOnFocus
        clearInputAfterSelect
        fullWidth
        actLikeASelect={false}
        showClearButton
        clearSelect={(...args) => clearDoctorDoctorFilterOption(...args)}
        {...props}
        childrenSuggestion={(item) => <SearchSuggestion suggestion={item} />}
      />
    </>
  );
};
export { StoreDoctorFilter as default, StoreDoctorFilter };
